'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _picq = require('./picq.html');

var _picq2 = _interopRequireDefault(_picq);

var _picq3 = require('./picq.controller');

var _picq4 = _interopRequireDefault(_picq3);

require('./picq.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var picqComponent = {
  restrict: 'E',
  bindings: {},
  template: _picq2.default,
  controller: _picq4.default,
  controllerAs: 'vm'
};

exports.default = picqComponent;


// WEBPACK FOOTER //
// ./client/app/common/reports/picq/picq.component.js